import React from "react";
import { numberFormatCommaTwoFraction } from "./../../../common/js/utils/numberFormat";

function SpecialConditionDetailTypes4({ specialCondition }) {
    return (<>
        <div>Percentage: {numberFormatCommaTwoFraction(specialCondition.percentage * 100)} %</div>
        <div>Tiers number: {((specialCondition.percentage * 100) / 5)}</div>
        <div>Minimum Print: {specialCondition.minimumImp.toLocaleString(undefined, { maximumFractionDigits: 2 })}</div>
    </>);
}

export default SpecialConditionDetailTypes4;